import { useAuth } from "@/context/AuthContext";
import { UserCog } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ImpersonationBanner() {
  const { impersonating, user, stopImpersonate } = useAuth();
  const navigate = useNavigate();
  if (!impersonating || !user) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-gold text-ink-950 text-sm font-heading font-bold px-4 py-1.5 flex items-center justify-center gap-3" data-testid="impersonation-banner">
      <UserCog size={15} /> <span>Acting as {user.username || user.name}</span>
      <button onClick={async () => { await stopImpersonate(); navigate("/admin"); }} data-testid="stop-impersonate" className="underline underline-offset-2 hover:opacity-80">Exit to admin</button>
    </div>
  );
}
